import { render, staticRenderFns } from "./electric-edit.vue?vue&type=template&id=5706611a&scoped=true&"
import script from "./electric-edit.vue?vue&type=script&lang=js&"
export * from "./electric-edit.vue?vue&type=script&lang=js&"
import style0 from "./electric-edit.vue?vue&type=style&index=0&id=5706611a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5706611a",
  null
  
)

export default component.exports